import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import helloSuperStarLogo from "../../../../Assets/Images/HelloSuperStarLogo.png";
import meetUpEvent1 from "../../../../Assets/Images/MeetUpevent(1).png";
import meetUpEvent2 from "../../../../Assets/Images/MeetUpevent(2).png";
import imagePath from "../../../CSS/imagePath";
import "./ParticipateReceipt.css";

const ref = React.createRef();

const ParticipateReceipt = (props) => {
  let docToPrint = React.createRef();

  const printDocument = () => {
    const input = docToPrint.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [570, 210],
        textAlign: "center",
      });
      pdf.addImage(imgData, "JPEG", 0, 0);
      // pdf.output("dataurlnewwindow");
      pdf.save(`${new Date().getTime()}_${props?.event?.venue}.pdf`);
    });
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        className="bigModal"
        dialogClassName="my-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="row justify-content-end">
          <div className="col-1 mt-2">
            <div className="btn btn-danger" onClick={props.onHide}>
              x
            </div>
          </div>
        </div>
        <Modal.Body ref={docToPrint} className="bg-warning modalBody m-5">
          <div className="row">
            <div
              className="col-md-4 backImage"
              style={{ backgroundImage: `url(${imagePath.meetUpEventImg})` }}
            ></div>

            <div className="col-md-4 p-0 m-0 middleCardBackground">
              <div className="text-center mt-5">
                <img
                  className="img-fluid superstarLogoImg"
                  src={helloSuperStarLogo}
                  alt=""
                />
              </div>
              <div className="focusText">
                <div className="text-white text-center p-3">
                  <h3 className="fw-bolder">{props.event.title}</h3>
                </div>
              </div>
              <div className="mt-3">
                <div className="text-center">
                  <h2 className="dateText fw-bolder">
                    <span className="mx-2">
                      {moment(props?.event?.event_date).format("LL")}
                    </span>
                  </h2>
                  <p className="text-white">
                    <small>{props.event.venue}</small>{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4  bg-light  position-relative">
              <div className="text-center">
                <img src={meetUpEvent1} alt="" />
              </div>
              <div className="m-3">
                <div className="my-2">
                  <small>Name</small>
                  <h5 className="fw-bolder">
                    {localStorage.getItem("auth_name")}
                  </h5>
                </div>
                <div className="my-2">
                  <small>Adress</small>
                  <h5 className="fw-bolder">{props?.event?.venue}</h5>
                </div>
                <div className="my-2">
                  <small>Event host </small>
                  <h5 className="fw-bolder">
                    {props.event?.star?.first_name}{" "}
                    {props.event?.star?.last_name}
                  </h5>
                </div>
                <div className="my-2">
                  <small>Time</small>
                  <h5 className="fw-bolder">
                    {moment(props.event.start_time, "h:mm:ss").format("h:mm a")}
                    - {moment(props.event.end_time, "h:mm:ss").format("h:mm a")}
                  </h5>
                </div>
              </div>
              <div className="text-center mt-2">
                <img src={meetUpEvent2} alt="" />
              </div>
              {/* <div className="position-absolute top-50 start-50 translate-middle">
                                <img className="img-fluid" src={whiteCircleBox} alt="" />
                            </div> */}
            </div>
          </div>
        </Modal.Body>

        <div className="text-center mb-5">
          <button
            onClick={printDocument}
            className="btn btn-outline-warning  px-3 p-2"
          >
            Download
          </button>
        </div>
        {/* <Modal.Footer>
                    <Button onClick={props.onHide}>Close</Button>
                </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default ParticipateReceipt;
